const routes = [
    {
        name: 'index',
        path: '/',
        component: () => import('@/view/appIndex'),
        meta: {
            title: ' '
        }
    },
    {
        name: 'login',
        path: '/login',
        component: () => import('@/view/login/login'),
        meta: {
            title: '登录'
        }
    }
];

export default routes
